import { Box, Container, Text } from "@chakra-ui/react"
import { createFileRoute } from "@tanstack/react-router"

import TitleBar from "../../components/UI/TitleBar"
import { userHasPermission } from "../../utils"
import { useMemo } from "react"
import { NoPermission } from "../../components/UI/no-permission"

export const Route = createFileRoute("/_layout/ads")({
  component: Ads,
})


function Ads() {
  // Permission check
  const [ad_read] = useMemo(() => {
    return ["read"].map(
      (action) => userHasPermission([{ perm: `ads_overview_${action}`, is_allowed: false }])[0].is_allowed
    )
  }, [userHasPermission])

  if(!ad_read) return <NoPermission/>

  return (
    <Container maxW="full">
      <TitleBar title="Werbung" />
      <Box pt={12} m={4}>
        <Text fontSize="2xl">❗ NOCH NICHT IMPLEMENTIERT ❗</Text>
      </Box>
    </Container>
  )
}
